import * as React from 'react';
import {withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';


import DataTable, {
    DataTableColumnProps,
    Renderer,
    Filterer,
    DataTableButton,
    DataTableButtonReset
} from 'src/components/common/DataTable';

import TableRequestDTO from 'src/models/datatable/TableRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import ClientSubscriptionDTO from 'src/models/client/ClientSubscriptionDTO';
import ClientApiController from 'src/api/ClientApiController';

import * as moment from 'moment';
import { Moment } from 'moment';
import AddEditClientSubscription from './AddEditClientSubscription';


export interface ClientSubscriptionsProps extends LocalizeContextProps {
    clientId: number;
}

interface ClientSubscriptionsState {
    loading: boolean;
    tableRecords: ClientSubscriptionDTO[];
    formRedirect: boolean;
}

class ClientSubscriptions extends React.Component<ClientSubscriptionsProps, ClientSubscriptionsState> {
    constructor(props: ClientSubscriptionsProps) {
        super(props);
        bindAllOfThis(this, ClientSubscriptions.prototype);

        this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false
        };
    }

    private fetchData(requestState: TableRequestDTO, checkEcho: () => boolean, callback: (response: TableResponseDTO<ClientSubscriptionDTO>) => void): void {
        this.setState({ loading: true });

        ClientApiController.getClientSubscriptionTableData(requestState, this.props.clientId)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                let tableRecords = results.data.results ? results.data.results : [];

                this.setState({
                    tableRecords: tableRecords,
                    loading: false
                });

                callback(results.data);
            });
    }

    private customTableColumns(): DataTableColumnProps<ClientSubscriptionDTO>[] {
        let editLink = (text, record: ClientSubscriptionDTO) => Routes.getRoute(Routes.ADMIN_ADD_EDIT_CLIENT_SUBSCRIPTION, this.props.clientId, record.clientSubscriptionId);

        return [
            DataTable.StandardColumns.Number('admin.clientSubscriptions.columnHeader1', 'maximumUserCount'),
            DataTable.StandardColumns.Date('admin.clientSubscriptions.columnHeader2', 'subscriptionStartDate'),
            DataTable.StandardColumns.Date('admin.clientSubscriptions.columnHeader3', 'subscriptionExpirationDate'),
            DataTable.StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit')
        ];
    }

    render() {
        if (this.state.formRedirect) {
            return <Redirect to={Routes.getRoute(Routes.ADMIN_ADD_EDIT_CLIENT_SUBSCRIPTION, this.props.clientId, 0)} push />;
        }

        return (
            <div>
                <h2>{this.props.translate("admin.clientSubscriptions.tableHeader")}</h2>

                <DataTable
                    serverSide={true}
                    tableProps={{ rowKey: 'clientSubscriptionId', loading: this.state.loading }}
                    columns={this.customTableColumns()}
                    data={this.state.tableRecords}
                    fetchData={this.fetchData}
                    buttonBar={[
                        new DataTableButton("admin.clientSubscriptions.addButton", () => { this.setState({ formRedirect: true }); }),
                        new DataTableButtonReset()
                    ]} />
            </div>
        );
    }
}

export default withLocalize(ClientSubscriptions as any) as any;



// WEBPACK FOOTER //
// ./src/pages/admin/ClientSubscriptions.tsx